export default {
  formatMinutes(value) {
    if(value && value > 0) {
      let minutes = Math.floor(value / 60);
      let seconds = value % 60;
      let sMinutes = '' + minutes;
      if(sMinutes.length === 1)
        sMinutes = '0' + minutes;
      let sSeconds = '' + seconds;
      if(sSeconds.length === 1)
        sSeconds = '0' + seconds;
      return sMinutes + ':' + sSeconds;
    } else
      return '00:00';
  }
}



// WEBPACK FOOTER //
// ./src/api/contest/time.js